import { PostingDetailsAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';

/**
 * Fetches posting details and transforms to entity
 *
 * @param {import('../types/PostingDetails.parameters').IGetPostingDetailsPayload} payload - Request payload
 * @returns {Promise<import('../types/PostingDetails').IPostingDetailsEntity>} Posting details entity
 */
export const getPostingDetails = async ({ postingId }) => {
  const response = await PermanentJobsApi.getPostingDetails({ postingId });

  return PostingDetailsAdapters.toPostingDetailsEntity(response.data);
};
